import { useEffect } from "react";
import SuccessScriptSVG from "../../assets/successScript.svg?react";

const SuccessScript = () => {
  useEffect(() => {
    const root = document.getElementById("root");
    if (root) {
      // TODO: Реализовать данные изменения через стили, попробовать сделать через styled components
      root.style.padding = "0";
      root.style.margin = "0";
      root.style.maxWidth = "100%";
    }

    return () => {
      if (root) {
        root.style.padding = "2rem";
        root.style.margin = "0 auto";
        root.style.maxWidth = "1280px";
      }
    };
  }, []);

  return (
    <div>
      <SuccessScriptSVG></SuccessScriptSVG>
    </div>
  );
};

export default SuccessScript;
